import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-check\">\n<path d=\"M10.8,3.8L5.5,9.5C5.4,9.7,5.2,9.7,5,9.7c-0.2,0-0.4-0.1-0.6-0.2L1.2,6.1c-0.3-0.3-0.2-0.9,0-1.2C1.5,4.5,2,4.5,2.3,4.8\n\tl2.7,2.8l4.7-5.1c0.3-0.4,0.8-0.4,1.2,0C11.1,2.9,11.1,3.4,10.8,3.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol